export enum TemplateType {
    TEMPLATE_T1 = 'T1',
    TEMPLATE_T2 = 'T2',
}